// React
import React, { useEffect, useState } from 'react'

// Appt

// Font Awesome


import CreatableSelect from 'react-select/creatable';

import FormService from '../../../services/FormService.js'
import PulseLoader from 'react-spinners/PulseLoader.js'

/**
 * `Small` renders a Card to display a counter of items eg. number of posts
 */
export default function LocationSelection(props) {


    const [locations, setLocations] = useState([])
    const [selectedLocation, setSelectedLocation] = useState(props.value ? { value: props.value, label: props.value } : null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        fetchLocations()
    }, [])

    const fetchLocations = async () => {
        setIsLoading(true)
        try {
            const response = await FormService.getCommonLocations()

            let options = response.map(location => ({ value: location, label: location }))
            setLocations(options)
        } catch (error) {
            console.error('Error fetching locations:', error)
        }
        setIsLoading(false)
    }

    let mainColor = '#ff8300'
    let secondaryColor = '#04124C'

    if (props?.secondary) {
        mainColor = '#04124C'
        secondaryColor = '#ff8300'
    }


    return (
        <>
            {!isLoading && <CreatableSelect 
                isClearable 
                options={locations} 
                onChange={(newValue) => {
                    setSelectedLocation(newValue)
                    props.onChange(newValue ? newValue.value : '')
                }}
                value={selectedLocation || props.value ? { value: props.value, label: props.value } : null}
                placeholder={"Location: " + props?.value}

            />}
            {isLoading && <PulseLoader color={mainColor} size={10}   />}
        </>
    )
}

